module.exports = __webpack_public_path__ + "static/media/recyclebin.da860425.gif";